export const getCurrentN = (cells, active) => {
  if (active.dir === "→") {
    for (let x = active.x; x >= 0; --x) {
      const cell = cells[active.y][x]
      if (cell.n !== null) {
        return cell.n
      }
    }
  } else {
    for (let y = active.y; y >= 0; --y) {
      const cell = cells[y][active.x]
      if (cell.n !== null) {
        return cell.n
      }
    }
  }
}

export const getCurrentAndNextWord = (cells, active) => {
  const n = getCurrentN(cells, active),
    xs = cells.flat().filter((c) => c.n !== null)

  // encuentro el current index y el next index
  const cix = xs.findIndex((x) => x.n === n && x.dir.includes(active.dir)),
    nix = (cix + 1) % xs.length,
    current = xs[cix],
    next = xs[nix],
    currentWord = { x: current.x, y: current.y, dir: current.dir, n },
    nextWord = { x: next.x, y: next.y, dir: next.dir, n: next.n }

  return {
    current: currentWord,
    next: nextWord,
  }
}
const opposite = (flechita) => (flechita === "→" ? "↓" : "→")

export const getNewActive = (cell, active, size) => {
  let isDualDir = cell.dir === "→↓" || cell.dir === "↓→",
    isSamePosition = cell.x === active.x && cell.y === active.y

  let newDir

  if (isSamePosition && isDualDir) newDir = opposite(active.dir)
  else if (isSamePosition && !isDualDir) newDir = active.dir
  else if (!isSamePosition && isDualDir)
    newDir = "→" // en caso de ser dual, toma por defecto → primero
  else if (!isSamePosition && !isDualDir) newDir = cell.dir

  let newPos = isSamePosition
    ? { x: active.x, y: active.y }
    : { x: cell.x, y: cell.y }

  let isOnRightEdge = newPos.x === size - 1
  newDir = isOnRightEdge ? "↓" : newDir

  return {
    ...newPos,
    dir: newDir,
  }
}
